module.exports = __webpack_public_path__ + "img/uefa_live_countdown_bg.7a9dc740.jpg";